"use strict";

import Vue from "vue";
import axios from "axios";
//import VueRouter from 'vue-router';
self = this;
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
axios.defaults.headers.common["Authorization"] =
  "bearer " + sessionStorage.getItem("token");
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  //baseURL: process.env.baseURL || process.env.apiUrl || ""
  //baseURL: "http://192.168.99.100:8888/v1/",
  baseURL: "https://api.cardapio.ommini.com.br/v1/",

  headers: {
    Authorization: "bearer " + sessionStorage.getItem("token"),
  },
  timeout: 60 * 1000, // Timeout
  withCredentials: false, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent

    config.headers["Authorization"] =
      "bearer " + sessionStorage.getItem("token");
    return config;
  },
  function (error) {
    if (error.response.data.error == "token_not_provided") {
      window.location.href = "/";
    }
    if (error.response.data.error == "token_expired") {
      window.location.href = "/";
    }
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error
    // console.log(error);
    if (error.response.data.error == "token_not_provided") {
      window.location.href = "/";
    }
    if (error.response.data.error == "token_expired") {
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;